import { Button, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import validator from 'validator';

const SignupCard = ({
  email,
  setEmail,
  error,
  agreeToTerms,
  setAgreeToTerms,
  handleSignup,
  signupDisabled,
  loading,
}) => {
  return (
    <div className="card-wrapper">
      <div className="card-wrapper-box">
        <h4>Sign up for a new payments account</h4>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSignup();
          }}
        >
          <div className="input-box">
            <TextField
              fullWidth
              // error={error}
              type="email"
              label="Email"
              placeholder="Enter your email"
              id="signup-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* <button
          className="login-btn"
          onClick={handleSignup}
          disabled={signupDisabled}
        >
          Sign up with OTP
        </button> */}
          <div className="privacy-policy">
            <input
              type="checkbox"
              id="signup-terms-checkbox"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
            />
            {console.log(process.env.REACT_WEBISTE_ENDPOINT)}
            <p>
              By Signing up, you agree to{' '}
              <Link
                id="signup-terms-link"
                to={`${process.env.REACT_APP_WEBISTE_ENDPOINT}/policy/termsOfUse`}
                target="_blank"
              >
                Terms of Use
              </Link>{' '}
              & {' '}
              <Link
                id="signup-privacy-link"
                to={`${process.env.REACT_APP_WEBISTE_ENDPOINT}/policy/privacy`}
                target="_blank"
              >
                Privacy Notice
              </Link>
            </p>
          </div>
          <Button
            fullWidth
            variant="contained"
            type="submit"
            id="signup-button"
            disabled={
              signupDisabled ||
              !validator.isEmail(email) ||
              !agreeToTerms ||
              loading
            }
          >
            {loading ? (
              <CircularProgress style={{ color: '#fff' }} size={26} />
            ) : (
              'Sign up with OTP'
            )}
          </Button>
        </form>
      </div>

      <div className="sign-up-link">
        <p>
          Already have an account? <Link id="signup-login-link" to="/login">Log In</Link>
        </p>
      </div>
    </div>
  );
};

export default SignupCard;
